// extracted by mini-css-extract-plugin
export var fadeIn = "_mm-1";
export var modalContent = "_mm-3";
export var overlay = "_mm-0";
export var popoverContent = "_mm-2";
export var results = "_mm-5";
export var searchInputWrapper = "_mm-4";